import React from 'react';
import Navbar from './Navbar';
import { useInAdminShell } from './AdminShell';

/** Renders the classic top navbar only outside the Admin sidebar shell. */
export default function PageNavbar() {
  const inShell = useInAdminShell();
  if (inShell) return null;
  return <Navbar />;
}
